import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from '@mui/material';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

import { customPalette } from '../../../styles/theme';

export const HintContainer = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px 24px;
  background-color: ${() => customPalette.grey['100']};
  border-radius: 4px;
  width: 100%;

  .info-icon-small {
    font-size: 24px;
  }
`;

export const StyledInfoIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.palette.info.main};
  font-size: 24px;

  &.small {
    font-size: 24px;
  }

  &.clickable {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const StyledText = styled(Typography)`
  color: ${({ theme }) => theme.palette.info.main};
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const ExpandedHintText = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  flex-grow: 1;
  white-space: pre-wrap;
`;

export const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  padding: 4px 0;
  resize: none;
  min-height: 24px;
  flex-grow: 1;
  white-space: pre-wrap;

  &:focus {
    outline: none;
    border-bottom-color: ${({ theme }) => theme.palette.primary.main};
  }

  &::placeholder {
    color: ${({ theme }) => theme.palette.grey[400]};
  }
`;

export const EditButtons = styled('div')`
  display: flex;
  gap: 4px;
  margin-left: auto;

  .save-icon {
    color: ${customPalette.positive[600]};
  }

  .clear-icon {
    color: ${customPalette.negative[600]};
  }
`;

export const IconOnlyWrapper = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px;

  &:hover {
    opacity: 0.8;
  }
`;
